import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlanoContaMatrizInserirComponent } from './plano-contas-matriz-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: PlanoContaMatrizInserirComponent }
    ])],
    exports: [RouterModule]
})
export class PlanoContaMatrizInserirRoutingModule { }
